__turbopack_context__.v({
  "content": "FoodOptimizationSection-module__ky4AfG__content",
  "optimizationContent": "FoodOptimizationSection-module__ky4AfG__optimizationContent",
  "optimizationElement": "FoodOptimizationSection-module__ky4AfG__optimizationElement",
  "root": "FoodOptimizationSection-module__ky4AfG__root" + " " + __turbopack_context__.i(768839)["sectionPadding"],
});
